// Normalise a pasted video URL to something safe to embed in an <iframe>.
// Handles Google Drive, YouTube (watch / shortlink / shorts), Vimeo.
// Returns { embedUrl, provider } or null if the URL isn't recognised.

export function normalizeVideoUrl(raw) {
  if (!raw) return null;
  let url;
  try { url = new URL(raw.trim()); } catch { return null; }
  const host = url.hostname.replace(/^www\./, "");

  // Google Drive: /file/d/{ID}/... or /open?id={ID}
  if (host === "drive.google.com" || host === "docs.google.com") {
    let id = null;
    const m = url.pathname.match(/\/file\/d\/([^/]+)/);
    if (m) id = m[1];
    if (!id) id = url.searchParams.get("id");
    if (id) return { embedUrl: `https://drive.google.com/file/d/${id}/preview`, provider: "gdrive" };
  }

  // YouTube: watch?v=, youtu.be/, shorts/, /embed/
  if (host === "youtube.com" || host === "m.youtube.com" || host === "youtu.be") {
    let id = null;
    if (host === "youtu.be") id = url.pathname.slice(1);
    else if (url.pathname.startsWith("/watch")) id = url.searchParams.get("v");
    else if (url.pathname.startsWith("/shorts/")) id = url.pathname.split("/")[2];
    else if (url.pathname.startsWith("/embed/")) id = url.pathname.split("/")[2];
    if (id) return { embedUrl: `https://www.youtube.com/embed/${id}`, provider: "youtube" };
  }

  // Vimeo: vimeo.com/{ID}
  if (host === "vimeo.com" || host === "player.vimeo.com") {
    const m = url.pathname.match(/\/(\d+)/);
    if (m) return { embedUrl: `https://player.vimeo.com/video/${m[1]}`, provider: "vimeo" };
  }

  // Fallback: assume the URL is already embeddable
  return { embedUrl: raw, provider: "other" };
}
